import {AsyncPipe, NgClass, NgIf} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {TranslateModule} from '@ngx-translate/core';
import {AppInstallService} from '../../../core/services/app-install.service';

@Component({
  selector: 'app-install-cta',
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    NgClass,
    ButtonModule,
    TranslateModule
  ],
  templateUrl: './app-install-cta.component.html',
  styleUrl: './app-install-cta.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppInstallCtaComponent {
  @Input() public compact: boolean = false;

  constructor(
    public readonly appInstall: AppInstallService
  ) {
  }
}
